const baseAuthSettings = {
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH',
}

const baseOAuthSettings = {
    redirectSignIn: `${window.location.origin}/?callback`,
    redirectSignOut: `${window.location.origin}/?signout`,
    responseType: 'code',
    scope: ['openid', 'email', 'profile'],
}

const sentryBaseSettings = {
    dsn: 'https://64f8f13271844c3cb4bd82b6f540b382@o1250291.ingest.sentry.io/6414492',
    tracesSampleRate: 1.0,
}

const baseSettings = {
    bscScanKey: 'CCHNZN82ZTD3IQ9UTEHMGX3128DQQYJ33M',
    alchemyPolygonKey: 'USZhMxSSLuqNgzkrOIuDAOYVAyzT54tR',
    alchemyMainnetKey: '6qWG11OQkY9RUyIYIgiYsSJGiEOgyE89',
    alchemyArbitrumKey: 'FY36eARyS3ZbGpG2g88XEJ18fl8bE1kD',
    alchemyOptimismKey: 'khoRjoOTMnjpiCJQlemK5FHQbKcYVP3t',
    quicknodeBSCKey: 'b1dfd07aefbc83fdefac19190e6169b26b591a82',
    quicknodeAvalancheKey: 'eda23599159d1c69cb5c0199c461569ce5e91a0b',
    splitApiToken: 'o9dfjf899gck8b857fppot41eboa9d3mh893',
    intercomOrgId: 'sc3pepw3',
    tagManagerConfig: {
        gtmId: 'GTM-PSDMKV9',
    },
    methodFi: {
        env: 'dev',
    },
    growsurfCampaignId: '4nd5l9',
    _1FlowKey:
        'oneflow_prod_N6gw2rMqCrRPidOlIlZzt37psT9r5Kvp1MsdQeFmzWlaQy69iRz5cG58vA/LeF6AasT6e6SX8QEUl08lc7KMuA==',
    fullstoryOrgId: 'o-1G899Y-na1',
    highlightProjectId: 'odzqq4dp',
    envName: 'base',
    commitHash: import.meta.env.VITE_COMMIT_HASH ?? 'dev',
}

const devConfig = {
    ...baseSettings,
    segmentKey: 'oFH2O8w8YLlON2B8XZ7eA4cKGFidZTMT',
    graphqlEndpoint: 'https://api-dev.spritz.finance/graphql',
    auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_t9wnpn79R',
        userPoolWebClientId: '16cij1j1c8h19i02plv1lg6rdr',
        ...baseAuthSettings,
        oauth: {
            ...baseOAuthSettings,
            domain: 'auth-dev.spritz.finance',
        },
    },
    cognito: {
        publishableKey: 'sandbox_publishable_key_c2da90cb7294dd67a77fb5f4437a501f',
        templateId: 'flwtmp_3qvjBHWc1uo4JQ',
    },
    sentry: {
        ...sentryBaseSettings,
        environment: 'dev',
    },
    envName: 'dev',
}

const localConfig = {
    ...devConfig,
    graphqlEndpoint: 'http://localhost:4000',
}

const stagingConfig = {
    ...baseSettings,
    segmentKey: 'iSf1YeGPceXFmrR86hW8zoVHMKoraUAC',
    graphqlEndpoint: 'https://api-staging.spritz.finance/graphql',
    auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_ZA6egh3bW',
        userPoolWebClientId: '1u47nrdl34m0k5fo2euh49jf2b',
        ...baseAuthSettings,
        oauth: {
            ...baseOAuthSettings,
            domain: 'auth-staging.spritz.finance',
        },
    },
    cognito: {
        publishableKey: 'sandbox_publishable_key_c2da90cb7294dd67a77fb5f4437a501f',
        templateId: 'flwtmp_3qvjBHWc1uo4JQ',
    },
    sentry: {
        ...sentryBaseSettings,
        environment: 'staging',
    },
    envName: 'staging',
}

const productionConfig = {
    ...baseSettings,
    splitApiToken: 'nbe6dugu7ah9g11vlsrhndinkao6rajqarmu',
    segmentKey: 'gtvVEZNFgXRC3udnHHFxy1CjOc7JnPLx',
    graphqlEndpoint: 'https://api.spritz.finance/graphql',
    auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_Iy2iXvYys',
        userPoolWebClientId: '6u6ho7obpot0bdc3i111ml89cv',
        ...baseAuthSettings,
        oauth: {
            ...baseOAuthSettings,
            domain: 'auth.spritz.finance',
        },
    },
    cognito: {
        publishableKey: 'live_publishable_key_78c7fbfd00a86437c5c94ad505b43412',
        templateId: 'flwtmp_2medms8vUPhpyo',
    },
    sentry: {
        ...sentryBaseSettings,
        environment: 'production',
    },
    growsurfCampaignId: 'b3ywg1',
    methodFi: {
        env: 'production',
    },
    envName: 'production',
}

const productionUrls = ['app.spritz.finance', 'quickswap.spritz.finance']

export const isProduction = () => {
    return productionUrls.includes(window.location.host)
}

export const isLocal = () => {
    return ['localdev.spritz.finance:3000', 'localhost:3000'].includes(window.location.host)
}

export const getConfig = () => {
    switch (window.location.host) {
        case 'app.spritz.finance':
        case 'quickswap.spritz.finance':
            return productionConfig
        case 'quickswap-staging.spritz.finance':
        case 'app-staging.spritz.finance':
            return stagingConfig
        case 'localdev.spritz.finance:3000':
        case 'localhost:3000':
            return localConfig
        case 'app-dev.spritz.finance':
        default:
            return devConfig
    }
}

export const config = getConfig()
